<div class="user-profile-settings-container no-select">

  <div class="widget-div">

    @if (canOrderingSettingsBeViewed) {
      <app-shared-widget-container-component>
        <div title class="widget-div-heading">
          <app-display-icon
            [tooltip]="canOrderingSettingsBeEdited ? tooltips.editAccessGranted : tooltips.editAccessDenied"
            [icon]="canOrderingSettingsBeEdited ? icons.lockOpenOutline : icons.lockClosedOutline">
          </app-display-icon>
          <div>Order Settings</div>
          <app-display-icon
            [tooltip]="tooltips.orderSettings"
            [icon]="icons.infoSlabCircleOutline"
            [colour]="iconColours.secondary">
          </app-display-icon>
        </div>
        <div block>
          <form [formGroup]="formOrderingSettings">

            @if (formOrderingSettings?.controls['orderNumber']) {
              <div class="form-column min-width">
                <div class="form-control-div">
                  <label for="orderNumber" class="required-field">Order Number</label>
                  <input
                    [matTooltip]="utilText.orderNumber.tooltip"
                    [class.invalid]="formOrderingSettings?.controls['orderNumber']?.errors"
                    [formControlName]="'orderNumber'"
                    [placeholder]="placeholders.features.orderSettings.orderNumberPlaceholder"
                    id="orderNumber"
                    type="text" />
                  <p class="required-fields-note">{{ requiredFieldsNote }}</p>
                </div>
              </div>
            }

            @if (formOrderingSettings?.controls['contactName']) {
              <div class="form-column min-width">
                <div class="form-control-div">
                  <label for="contactName" class="required-field">Contact Name</label>
                  <input
                    [matTooltip]="utilText.contactName.tooltip"
                    [class.invalid]="formOrderingSettings?.controls['contactName']?.errors"
                    [formControlName]="'contactName'"
                    [placeholder]="placeholders.features.orderSettings.contactNamePlaceholder"
                    id="contactName"
                    type="text" />
                  <p class="required-fields-note">{{ requiredFieldsNote }}</p>
                </div>
              </div>
            }

            @if (formOrderingSettings?.controls['contactNumber']) {
              <div class="form-column min-width">
                <div class="form-control-div">
                  <label for="contactNumber" class="required-field">Contact Number</label>
                  <input
                    [matTooltip]="utilText.contactNumber.tooltip"
                    [class.invalid]="formOrderingSettings?.controls['contactNumber']?.errors"
                    [formControlName]="'contactNumber'"
                    [placeholder]="placeholders.features.orderSettings.contactNumberPlaceholder"
                    id="contactNumber"
                    type="text" />
                  <p class="required-fields-note">{{ requiredFieldsNote }}</p>
                </div>
              </div>
            }

            @if (formOrderingSettings?.controls['ccRecipients-0']) {
              <div class="form-column full-width">
                <div class="form-control-div row-flex">
                  <label [for]="'ccRecipients-0'">CC Recipients</label>
                  @for (numb of indexCcRecipients; track $index) {
                    @if (formOrderingSettings?.controls['ccRecipients-' + numb]) {
                      <input
                        [matTooltip]="utilText.ccRecipient.tooltip"
                        [class.invalid]="formOrderingSettings?.controls['ccRecipients-' + numb]?.errors"
                        [formControlName]="'ccRecipients-' + numb"
                        [id]="'ccRecipients-' + numb"
                        [placeholder]="placeholders.features.orderSettings.ccRecipientPlaceholder"
                        type="text" />
                      <button
                        [id]="'btn-ccRecipients-' + numb"
                        type="button"
                        class="action-button"
                        [disabled]="canOrderingSettingsBeEdited === false"
                        (click)="onAddRecipientClick()">
                        <app-display-icon
                          [colour]="canOrderingSettingsBeEdited === false ? iconColours.disabled : iconColours.secondary"
                          [tooltip]="tooltips.ccRecipientAdd"
                          [icon]="icons.emailPlusOutline">
                        </app-display-icon>
                      </button>
                      <button
                        type="button"
                        class="action-button btn-remove"
                        [disabled]="canOrderingSettingsBeEdited === false"
                        (click)="onRemoveRecipientClick(numb, $index)">
                        <app-display-icon
                          [colour]="canOrderingSettingsBeEdited === false ? iconColours.disabled : iconColours.red"
                          [tooltip]="$index === 0 ? 'Clear primary recipient' : tooltips.ccRecipientRemove"
                          [icon]="icons.emailRemove">
                        </app-display-icon>
                      </button>
                    }
                  }
                </div>
              </div>
            }

            @if (formOrderingSettings?.controls['subject']) {
              <div class="form-column full-width">
                <div class="form-control-div row-flex-260">
                  <div class="label-row">
                    <label for="subject" class="required-field">Subject</label>
                    <button
                      type="button"
                      class="action-button"
                      (click)="revertToPlaceholder('subject')">
                      <app-display-icon
                        [colour]="iconColours.constant_white"
                        [tooltip]="tooltips.undoChanges"
                        [icon]="icons.undo">
                      </app-display-icon>
                    </button>
                  </div>
                  <input
                    [matTooltip]="utilText.emailSubject.tooltip"
                    [class.invalid]="formOrderingSettings?.controls['subject']?.errors"
                    [formControlName]="'subject'"
                    [placeholder]="placeholders.features.orderSettings.subjectPlaceholder"
                    id="subject"
                    type="text" />
                  <p class="required-fields-note">{{ requiredFieldsNote }}</p>
                  <app-shared-custom-select
                    id="tokenSubjectSelect"
                    (selectionChange)="onSelectTokens($event, 'subject')"
                    [allowMultiple]="true"
                    [placeholder]="'Add Placeholders...'"
                    [selected]="[]"
                    [setOptions]="tokenOptions()"
                    [showChips]="false">
                  </app-shared-custom-select>
                </div>
              </div>
            }

            @if (formOrderingSettings?.controls['body']) {
              <div class="form-column full-width">

                <div class="form-control-div row-flex-260">
                  <div class="label-row">
                    <label for="body" class="required-field">Body</label>
                    <button
                      type="button"
                      class="action-button"
                      (click)="revertToPlaceholder('body')">
                      <app-display-icon
                        [colour]="iconColours.constant_white"
                        [tooltip]="tooltips.undoChanges"
                        [icon]="icons.undo">
                      </app-display-icon>
                    </button>
                  </div>
                  <div>
                    <textarea
                      [matTooltip]="utilText.emailBody.tooltip"
                      [class.invalid]="formOrderingSettings?.controls['body']?.errors"
                      [formControlName]="'body'"
                      [placeholder]="textAreaPlaceholder"
                      id="body"
                      rows="6"
                      type="text">
                    </textarea>
                    <p class="required-fields-note">{{ requiredFieldsNote }}</p>
                    <app-shared-custom-select id="tokenBodySelect"
                                              (selectionChange)="onSelectTokens($event, 'body')"
                                              [allowMultiple]="true"
                                              [placeholder]="'Add Placeholders...'"
                                              [selected]="[]"
                                              [setOptions]="tokenOptions()"
                                              [showChips]="false">
                    </app-shared-custom-select>
                  </div>
                </div>
              </div>
            }

            @if (formOrderingSettings?.controls['pdfClause']) {
              <div class="form-column min-width">
                <div class="form-control-div">
                  <label for="pdfClause">PDF Clause</label>
                  <input
                    [matTooltip]="utilText.deliveryClause.tooltip"
                    [class.invalid]="formOrderingSettings?.controls['pdfClause']?.errors"
                    [formControlName]="'pdfClause'"
                    [placeholder]="placeholders.features.orderSettings.pdfClausePlaceholder"
                    id="pdfClause"
                    type="text" />
                </div>
              </div>
            }

          </form>
        </div>
        <div actions class="widget-actions">
          @if (hasOrderingSettingsErrors?.length > 0) {
            @for (field of hasOrderingSettingsErrors; track $index) {
              <button
                type="button"
                class="error-button">
                <app-display-icon
                  [colour]="iconColours.red"
                  [tooltip]="field?.error"
                  [icon]="icons.alertRhombusOutline">
                </app-display-icon>
              </button>
            }
          }
          @if (hasOrderingSettingsBeenEdited) {
            <button
              type="button"
              class="action-button"
              [disabled]="canOrderingSettingsBeEdited === false"
              (click)="onRevertForm('orderingSettings')">
              <app-display-icon
                [colour]="canOrderingSettingsBeEdited === false ? iconColours.disabled : iconColours.secondary"
                [tooltip]="tooltips.undoChanges"
                [icon]="icons.undo">
              </app-display-icon>
            </button>
          }
          @if (canOrderingSettingsBeSubmitted) {
            <button
              type="button"
              class="action-button"
              [disabled]="isOrderingSettingsSubmitDisabled"
              (click)="onSubmitForm('orderingSettings')">
              <app-display-icon
                [colour]="isOrderingSettingsSubmitDisabled ? iconColours.disabled : iconColours.secondary"
                [tooltip]="tooltips.saveChanges"
                [icon]="icons.contentSaveOutline">
              </app-display-icon>
            </button>
          }
        </div>
      </app-shared-widget-container-component>
    }

  </div>

  @if (!hideActionBar) {
  <div class="ups-container-action-bar widget-actions">
    @if (hasOrderingSettingsErrors?.length > 0) {
      @for (field of hasOrderingSettingsErrors; track $index) {
        <button
          type="button"
          class="error-button">
          <app-display-icon
            [colour]=" iconColours.red"
            [tooltip]="field?.error"
            [icon]="icons.alertRhombusOutline">
          </app-display-icon>
        </button>
      }
    }
    <button
      [disabled]="!haveAnyEditsBeenMade && canOrderingSettingsBeEdited"
      type="button"
      class="action-button"
      (click)="onRevertForm('all')">
      <app-display-icon
        [colour]="iconColours.secondary"
        [tooltip]="tooltips.undoAllChanges"
        [icon]="icons.undo">
      </app-display-icon>
      Undo Changes
    </button>
    <button
      type="button"
      class="action-button"
      [disabled]="isOrderingSettingsSubmitDisabled"
      (click)="onSubmitForm('orderingSettings')">
      <app-display-icon
        [colour]="isOrderingSettingsSubmitDisabled ? iconColours.disabled : iconColours.secondary"
        [tooltip]="tooltips.saveChanges"
        [icon]="icons.contentSaveOutline">
      </app-display-icon>
      Save Order Settings
    </button>
  </div>
  }

</div>
